import { FRONT_KEY } from "@Constants/frontKey";
import ShopStockOverviewPage from "@Local/ClubInventory/ShopStockOverviewPage";
import ShopStockDetailPage from "@Local/ClubInventory/ShopStockDetailPage";
import ProductStockOverviewPage from "@Local/ClubInventory/ProductStockOverviewPage";
import ProductStockDetailPage from "@Local/ClubInventory/ProductStockDetailPage";
import {
	CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_ROUTER,
	CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW_ROUTER,
	CLUB_INVENTORY_SHOP_STOCK_DETAIL_ROUTER,
	CLUB_INVENTORY_SHOP_STOCK_OVERVIEW_ROUTER,
} from "@Router/routerPath";

const clubInventoryRouter = [
	{
		description: "店鋪庫存管理",
		frontKey: FRONT_KEY.CLUB_INVENTORY,
	},
	{
		description: "店鋪庫存總覽",
		frontKey: FRONT_KEY.CLUB_INVENTORY_SHOP_STOCK_OVERVIEW,
		static: true,
		exact: true,
		path: CLUB_INVENTORY_SHOP_STOCK_OVERVIEW_ROUTER,
		href: CLUB_INVENTORY_SHOP_STOCK_OVERVIEW_ROUTER,
		as: ShopStockOverviewPage,
	},
	{
		description: "店鋪庫存明細",
		frontKey: FRONT_KEY.CLUB_INVENTORY_SHOP_STOCK_DETAIL,
		static: true,
		exact: true,
		path: CLUB_INVENTORY_SHOP_STOCK_DETAIL_ROUTER,
		href: CLUB_INVENTORY_SHOP_STOCK_DETAIL_ROUTER,
		as: ShopStockDetailPage,
	},
	{
		description: "商品庫存總覽",
		frontKey: FRONT_KEY.CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW,
		static: true,
		exact: true,
		path: CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW_ROUTER,
		href: CLUB_INVENTORY_PRODUCT_STOCK_OVERVIEW_ROUTER,
		as: ProductStockOverviewPage,
	},
	{
		description: "商品庫存明細",
		frontKey: FRONT_KEY.CLUB_INVENTORY_PRODUCT_STOCK_DETAIL,
		static: true,
		exact: true,
		path: CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_ROUTER,
		href: CLUB_INVENTORY_PRODUCT_STOCK_DETAIL_ROUTER,
		as: ProductStockDetailPage,
	},
];

export default clubInventoryRouter;
